"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var App_1 = require("./App");
var apps_manifest_1 = require("@vidazoo/apps-manifest");
var theme = require("./theme.scss");
var button_1 = require("@vidazoo/ui/lib/components/button");
var label_1 = require("@vidazoo/ui/lib/components/label");
var icon_1 = require("@vidazoo/ui/lib/components/icon");
var mainMenu_1 = require("@vidazoo/ui/lib/components/mainMenu");
var collapsable_1 = require("@vidazoo/ui/lib/components/collapsable");
function isRelevantAdmin(roles) {
    return roles.find(function (_a) {
        var name = _a.name;
        return ["ROOT_ADMIN", "READ_ONLY_ADMIN"].includes(name);
    });
}
function transformScopesToAppManifests(scopes, excludeScope) {
    return scopes
        .filter(function (_a) {
        var scope = _a.scope, roles = _a.roles;
        return scope !== excludeScope && !!apps_manifest_1.default[scope] && (scope === "auth" ? isRelevantAdmin(roles) : true);
    })
        .map(function (_a) {
        var scope = _a.scope;
        return apps_manifest_1.default[scope];
    });
}
var VidazooApps = /** @class */ (function (_super) {
    tslib_1.__extends(VidazooApps, _super);
    function VidazooApps(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onToggleExpand = _this.onToggleExpand.bind(_this);
        _this.state = { expanded: false };
        return _this;
    }
    VidazooApps.prototype.onToggleExpand = function () {
        this.setState({
            expanded: !this.state.expanded
        });
    };
    VidazooApps.prototype.render = function () {
        var _a = this.props, userScopes = _a.userScopes, currentScope = _a.currentScope, maximumApps = _a.maximumApps, align = _a.align;
        var expanded = this.state.expanded;
        if (userScopes.length === 1) {
            return null;
        }
        var userManifest = transformScopesToAppManifests(userScopes, currentScope);
        var totalManifests = userManifest.length;
        var showMoreButton = totalManifests > maximumApps;
        var extraManifest;
        if (showMoreButton) {
            extraManifest = userManifest.slice(maximumApps);
            userManifest = userManifest.slice(0, maximumApps);
        }
        if (showMoreButton && !expanded) {
            userManifest = userManifest.slice(0, maximumApps);
        }
        return (React.createElement(mainMenu_1.MainMenu, { badgeColor: "blue", badgeLabel: (totalManifests).toString(), iconSize: 3, iconName: "icon-grid", stickTo: align },
            React.createElement("li", { className: theme.container },
                React.createElement("div", { className: theme.header },
                    React.createElement(icon_1.Icon, { iconName: "icon-network", size: 2.4 }),
                    React.createElement(label_1.Label, { uppercase: false }, "Vidazoo Apps")),
                React.createElement("div", { className: theme.inner },
                    React.createElement("div", { className: theme.apps }, userManifest.map(function (appManifest) { return (React.createElement(App_1.default, { key: appManifest.scope, manifest: appManifest })); })),
                    showMoreButton && (React.createElement(collapsable_1.Collapsable, { collapsed: !expanded },
                        React.createElement("div", { className: classnames(theme.apps, theme.extra) }, extraManifest.map(function (appManifest) { return (React.createElement(App_1.default, { key: appManifest.scope, manifest: appManifest })); }))))),
                showMoreButton && (React.createElement(button_1.Button, { onClick: this.onToggleExpand, fill: true, gray60: true, medium: true }, expanded ? "Show Less" : "Show More")))));
    };
    VidazooApps.defaultProps = {
        maximumApps: 9,
        align: "right"
    };
    return VidazooApps;
}(React.PureComponent));
exports.default = VidazooApps;
